// import { motion } from "framer-motion";
// import type { Variants } from "framer-motion";

// import {
//   BadgeCheck,
//   PackageCheck,
//   Globe2,
//   Truck,
//   Sparkles,
// } from "lucide-react";

// const features = [
//   {
//     title: "Quality Assured Products",
//     desc: "Strict quality controls at every stage to ensure consistent, reliable outcomes.",
//     icon: BadgeCheck,
//   },
//   {
//     title: "Excellent Product Packaging",
//     desc: "Export-ready packaging built for shelf appeal, safety, and compliance needs.",
//     icon: PackageCheck,
//   },
//   {
//     title: "Widespread Distribution Network",
//     desc: "Strong global reach with streamlined dispatch and partner coordination.",
//     icon: Globe2,
//   },
//   {
//     title: "Well-managed Logistics Facility",
//     desc: "Efficient logistics handling for timely, secure movement across markets.",
//     icon: Truck,
//   },
// ];

// // const container = {
// //   hidden: { opacity: 0 },
// //   show: {
// //     opacity: 1,
// //     transition: { staggerChildren: 0.12, delayChildren: 0.12 },
// //   },
// // };

// // const item = {
// //   hidden: { opacity: 0, y: 18 },
// //   show: { opacity: 1, y: 0, transition: { duration: 0.55, ease: "easeOut" } },
// // };

// const container: Variants = {
//   hidden: { opacity: 0 },
//   show: {
//     opacity: 1,
//     transition: { staggerChildren: 0.12, delayChildren: 0.12 },
//   },
// };

// const item: Variants = {
//   hidden: { opacity: 0, y: 18 },
//   show: {
//     opacity: 1,
//     y: 0,
//     transition: { duration: 0.55, ease: [0.16, 1, 0.3, 1] }, // ✅ valid
//   },
// };

// export default function WhatMakesUsSpecial() {
//   return (
//     <section className="relative bg-white py-16 md:py-24 overflow-hidden">
//       {/* Soft background glows */}
//       <div className="pointer-events-none absolute -top-24 -left-24 h-72 w-72 rounded-full blur-3xl opacity-10 bg-[#F47C20]" />
//       <div className="pointer-events-none absolute -bottom-24 -right-24 h-80 w-80 rounded-full blur-3xl opacity-10 bg-[#E83E6F]" />

//       <div className="max-w-7xl mx-auto px-6 md:px-8">
//         {/* Header */}
//         <motion.div
//           initial={{ opacity: 0, y: 16 }}
//           whileInView={{ opacity: 1, y: 0 }}
//           viewport={{ once: true, amount: 0.25 }}
//           transition={{ duration: 0.6, ease: "easeOut" }}
//           className="max-w-3xl"
//         >
//           <div className="inline-flex items-center gap-2 rounded-full border border-black/10 bg-black/[0.02] px-4 py-2">
//             <span className="h-2 w-2 rounded-full bg-gradient-to-r from-[#F47C20] to-[#E83E6F]" />
//             <span className="text-xs font-semibold tracking-[0.2em] uppercase text-[#2B2B2B]/80">
//               What Makes Us Special
//             </span>
//           </div>

//           <h2 className="mt-6 text-3xl md:text-5xl font-extrabold leading-tight text-[#1B1B1B]">
//             What Makes{" "}
//             <span className="bg-gradient-to-r from-[#F47C20] to-[#E83E6F] bg-clip-text text-transparent">
//               Us Special
//             </span>
//           </h2>

//           <p className="mt-5 text-base md:text-lg leading-relaxed text-[#2B2B2B]/80">
//             Amera Export stands apart as India&apos;s No.1 exporter of dietary
//             supplements, trusted by top brands in the USA and Europe. We utilize
//             cutting-edge technology and adhere to strict quality standards,
//             ensuring innovative and reliable manufacturing. Our experienced
//             team, rigorous quality control, and customer-centric approach make
//             us the partner of choice for tailored, world-class supplement
//             solutions, committed to excellence and innovation.
//           </p>
//         </motion.div>

//         {/* Feature Grid */}
//         <motion.div
//           variants={container}
//           initial="hidden"
//           whileInView="show"
//           viewport={{ once: true, amount: 0.2 }}
//           className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6"
//         >
//           {features.map((f) => {
//             const Icon = f.icon;
//             return (
//               <motion.div
//                 key={f.title}
//                 variants={item}
//                 whileHover={{ y: -6 }}
//                 className="group relative rounded-2xl border border-black/10 bg-white p-6 shadow-sm transition"
//               >
//                 {/* Hover glow border */}
//                 <div className="pointer-events-none absolute inset-0 rounded-2xl opacity-0 group-hover:opacity-100 transition duration-300">
//                   <div className="absolute inset-0 rounded-2xl bg-gradient-to-r from-[#F47C20]/20 to-[#E83E6F]/20" />
//                 </div>

//                 {/* Icon bubble */}
//                 <div className="relative z-10 flex items-center justify-between">
//                   <div className="h-12 w-12 rounded-xl bg-gradient-to-r from-[#F47C20] to-[#E83E6F] p-[1px]">
//                     <div className="h-full w-full rounded-xl bg-white flex items-center justify-center">
//                       <Icon className="text-[#C62828]" size={22} />
//                     </div>
//                   </div>

//                   <Sparkles
//                     size={18}
//                     className="text-[#C9A227] opacity-0 group-hover:opacity-100 transition duration-300"
//                   />
//                 </div>

//                 {/* Title */}
//                 <h3 className="relative z-10 mt-5 text-base font-semibold text-[#1B1B1B]">
//                   {f.title}
//                 </h3>

//                 {/* Description */}
//                 <p className="relative z-10 mt-2 text-sm leading-6 text-[#2B2B2B]/75">
//                   {f.desc}
//                 </p>

//                 {/* Bottom gradient line */}
//                 <div className="relative z-10 mt-6 h-[2px] w-16 bg-gradient-to-r from-[#F47C20] to-[#E83E6F] opacity-60 group-hover:opacity-100 transition" />
//               </motion.div>
//             );
//           })}
//         </motion.div>

//         {/* Bottom elegant strip */}
//         <motion.div
//           initial={{ opacity: 0, y: 14 }}
//           whileInView={{ opacity: 1, y: 0 }}
//           viewport={{ once: true, amount: 0.2 }}
//           transition={{ duration: 0.55, ease: "easeOut" }}
//           className="mt-12 rounded-2xl border border-black/10 bg-gradient-to-r from-[#FFF8F3] to-white p-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-4"
//         >
//           <div>
//             <p className="text-sm font-semibold text-[#1B1B1B]">
//               Built for Global Brands
//             </p>
//             <p className="mt-1 text-sm text-[#2B2B2B]/75">
//               Export-focused manufacturing with quality, consistency, and scalable delivery.
//             </p>
//           </div>

//           <motion.a
//             whileHover={{ y: -2 }}
//             whileTap={{ scale: 0.98 }}
//             href="/contact"
//             className="inline-flex items-center justify-center rounded-md px-6 py-3 text-sm font-semibold text-white
//                        bg-gradient-to-r from-[#F47C20] to-[#E83E6F]
//                        shadow-md shadow-black/10 hover:opacity-95 transition"
//           >
//             Talk to Us
//           </motion.a>
//         </motion.div>
//       </div>
//     </section>
//   );
// }

import { motion } from 'framer-motion'
import {
  BadgeCheck,
  PackageCheck,
  Globe2,
  Truck,
  Sparkles,
  MapPinned
} from 'lucide-react'

const features = [
  {
    title: 'Quality Assured Products',
    icon: BadgeCheck
  },
  {
    title: 'Excellent Product Packaging',
    icon: PackageCheck
  },
  {
    title: 'Widespread Distribution Network',
    icon: Globe2
  },
  {
    title: 'Well-managed Logistics Facility',
    icon: Truck
  }
]

export default function WhatMakesUsSpecial () {
  return (
    <section className='relative bg-white py-20 md:py-28 overflow-hidden'>
      {/* Soft ambient background glow */}
      <div className='absolute -top-32 -left-32 w-96 h-96 bg-[#F47C20]/10 rounded-full blur-3xl' />
      <div className='absolute -bottom-32 -right-32 w-96 h-96 bg-[#E83E6F]/10 rounded-full blur-3xl' />

      <div className='max-w-7xl mx-auto px-6 md:px-8 grid grid-cols-1 lg:grid-cols-2 gap-14 items-center'>
        {/* LEFT SIDE CONTENT */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <p className='uppercase tracking-[0.3em] text-sm font-semibold text-[#C62828]'>
            What Makes Us Special
          </p>

          <h2 className='mt-4 text-4xl md:text-5xl font-extrabold leading-tight text-[#1B1B1B]'>
            Global Excellence in{' '}
            <span className='bg-gradient-to-r from-[#F47C20] to-[#E83E6F] bg-clip-text text-transparent'>
              Supplement Manufacturing
            </span>
          </h2>

          <p className='mt-6 text-lg leading-relaxed text-[#2B2B2B]/80'>
            Amera Export stands apart as India’s No.1 exporter of dietary
            supplements, trusted by top brands in the USA and Europe. We combine
            advanced technology, strict quality standards, and a
            customer-centric approach to deliver world-class supplement
            solutions built for global success.
          </p>

          {/* Feature List */}
          <div className='mt-10 grid grid-cols-1 sm:grid-cols-2 gap-6'>
            {features.map((feature, index) => {
              const Icon = feature.icon
              return (
                <motion.div
                  key={index}
                  whileHover={{ y: -6 }}
                  className='flex items-center gap-4 p-5 rounded-xl border border-black/10 shadow-sm hover:shadow-md transition bg-white'
                >
                  <div className='h-12 w-12 rounded-xl bg-gradient-to-r from-[#F47C20] to-[#E83E6F] flex items-center justify-center text-white'>
                    <Icon size={22} />
                  </div>
                  <p className='font-semibold text-[#1B1B1B]'>
                    {feature.title}
                  </p>
                </motion.div>
              )
            })}
          </div>
        </motion.div>

        {/* RIGHT SIDE VISUAL / ANIMATED AREA */}
        {/* <div className="relative flex items-center justify-center min-h-[450px]"> */}

        {/* Rotating Ring */}
        {/* <motion.div
            animate={{ rotate: 360 }}
            transition={{ repeat: Infinity, duration: 20, ease: "linear" }}
            className="absolute w-80 h-80 border-2 border-dashed border-[#F47C20]/30 rounded-full"
          /> */}

        {/* Inner Glow Circle */}
        {/* <div className="absolute w-60 h-60 bg-gradient-to-br from-[#F47C20]/20 to-[#E83E6F]/20 rounded-full blur-2xl" /> */}

        {/* Floating Stats Card 1 */}
        {/* <motion.div
            animate={{ y: [0, -15, 0] }}
            transition={{ repeat: Infinity, duration: 6 }}
            className="absolute top-10 right-10 bg-white shadow-xl rounded-2xl px-6 py-5 border border-black/10"
          >
            <p className="text-2xl font-bold text-[#C62828]">15+</p>
            <p className="text-sm text-[#2B2B2B]/70">Global Markets</p>
          </motion.div> */}

        {/* Floating Stats Card 2 */}
        {/* <motion.div
            animate={{ y: [0, 15, 0] }}
            transition={{ repeat: Infinity, duration: 5 }}
            className="absolute bottom-12 left-10 bg-white shadow-xl rounded-2xl px-6 py-5 border border-black/10"
          >
            <p className="text-2xl font-bold text-[#F47C20]">100+</p>
            <p className="text-sm text-[#2B2B2B]/70">Premium Products</p>
          </motion.div> */}

        {/* Center Core */}
        {/* <motion.div
            whileHover={{ scale: 1.05 }}
            className="relative z-10 h-40 w-40 rounded-full bg-gradient-to-r from-[#F47C20] to-[#E83E6F] flex items-center justify-center shadow-2xl"
          >
            <MapPinned size={36} className="text-white" />
          </motion.div> */}
        {/* </div> */}
        {/* RIGHT SIDE VISUAL / ANIMATED AREA */}
        <div className='relative flex items-center justify-center min-h-[450px]'>
          {/* Outer soft glow */}
          <div className='absolute w-[430px] h-[430px] rounded-full bg-gradient-to-br from-[#F47C20]/10 to-[#E83E6F]/10 blur-2xl' />

          {/* Rotating Ring */}
          <motion.div
            animate={{ rotate: 360 }}
            transition={{ repeat: Infinity, duration: 26, ease: 'linear' }}
            className='absolute w-80 h-80 rounded-full border-2 border-dashed border-[#F47C20]/30'
          />

          {/* Inner Ring */}
          <motion.div
            animate={{ rotate: -360 }}
            transition={{ repeat: Infinity, duration: 34, ease: 'linear' }}
            className='absolute w-64 h-64 rounded-full border border-[#E83E6F]/25'
          />

          {/* Pulsing Export Nodes on ring */}
          {Array.from({ length: 8 }).map((_, i) => {
            const angle = (i / 8) * Math.PI * 2
            const r = 160 // radius in px
            const x = Math.cos(angle) * r
            const y = Math.sin(angle) * r

            return (
              <motion.div
                key={i}
                className='absolute'
                style={{ transform: `translate(${x}px, ${y}px)` }}
                animate={{ scale: [1, 1.45, 1], opacity: [0.6, 1, 0.6] }}
                transition={{
                  repeat: Infinity,
                  duration: 2.8 + (i % 3),
                  delay: i * 0.15
                }}
              >
                <div className='h-3 w-3 rounded-full bg-gradient-to-r from-[#F47C20] to-[#E83E6F] shadow-lg' />
              </motion.div>
            )
          })}

          {/* Logistics Route Lines */}
          <motion.div
            className='absolute w-[360px] h-[360px] rounded-full'
            style={{
              background:
                'conic-gradient(from 0deg, rgba(244,124,32,0.0), rgba(244,124,32,0.35), rgba(232,62,111,0.0))',
              maskImage: 'radial-gradient(circle, transparent 55%, black 56%)',
              WebkitMaskImage:
                'radial-gradient(circle, transparent 55%, black 56%)'
            }}
            animate={{ rotate: 360 }}
            transition={{ repeat: Infinity, duration: 14, ease: 'linear' }}
          />

          {/* Orbiting “Capsule” shapes (pure CSS, looks like products) */}
          <motion.div
            className='absolute w-[340px] h-[340px]'
            animate={{ rotate: 360 }}
            transition={{ repeat: Infinity, duration: 18, ease: 'linear' }}
          >
            {Array.from({ length: 6 }).map((_, i) => {
              const angle = (i / 6) * 360
              return (
                <div
                  key={i}
                  className='absolute left-1/2 top-1/2'
                  style={{ transform: `rotate(${angle}deg) translateX(170px)` }}
                >
                  <motion.div
                    animate={{ y: [0, -8, 0] }}
                    transition={{
                      repeat: Infinity,
                      duration: 3.5 + (i % 2),
                      delay: i * 0.2
                    }}
                    className='relative h-10 w-4 rounded-full shadow-lg'
                    style={{
                      background:
                        i % 2 === 0
                          ? 'linear-gradient(180deg, #F47C20 0%, #ffffff 50%, #E83E6F 100%)'
                          : 'linear-gradient(180deg, #E83E6F 0%, #ffffff 50%, #F47C20 100%)'
                    }}
                  >
                    {/* shiny highlight */}
                    <div className='absolute left-1 top-2 h-5 w-[2px] rounded-full bg-white/60' />
                  </motion.div>
                </div>
              )
            })}
          </motion.div>

          {/* Floating Stats Card 1 */}
          <motion.div
            animate={{ y: [0, -14, 0] }}
            transition={{ repeat: Infinity, duration: 6 }}
            className='absolute top-8 right-10 bg-white/90 backdrop-blur shadow-xl rounded-2xl px-6 py-5 border border-black/10'
          >
            <p className='text-2xl font-bold text-[#C62828]'>15+</p>
            <p className='text-sm text-[#2B2B2B]/70'>Global Markets</p>
          </motion.div>

          {/* Floating Stats Card 2 */}
          <motion.div
            animate={{ y: [0, 14, 0] }}
            transition={{ repeat: Infinity, duration: 5 }}
            className='absolute bottom-10 left-10 bg-white/90 backdrop-blur shadow-xl rounded-2xl px-6 py-5 border border-black/10'
          >
            <p className='text-2xl font-bold text-[#F47C20]'>100+</p>
            <p className='text-sm text-[#2B2B2B]/70'>Premium Products</p>
          </motion.div>

          {/* NEW: Micro Cards (Quality / Packaging / Logistics) */}
          <motion.div
            animate={{ x: [0, 8, 0] }}
            transition={{ repeat: Infinity, duration: 6.5 }}
            className='absolute left-8 top-20 bg-white/90 backdrop-blur shadow-lg rounded-xl px-4 py-3 border border-black/10 flex items-center gap-2'
          >
            <BadgeCheck size={18} className='text-[#F47C20]' />
            <p className='text-sm font-semibold text-[#1B1B1B]'>Quality</p>
          </motion.div>

          <motion.div
            animate={{ x: [0, -8, 0] }}
            transition={{ repeat: Infinity, duration: 7.2 }}
            className='absolute right-8 bottom-24 bg-white/90 backdrop-blur shadow-lg rounded-xl px-4 py-3 border border-black/10 flex items-center gap-2'
          >
            <PackageCheck size={18} className='text-[#E83E6F]' />
            <p className='text-sm font-semibold text-[#1B1B1B]'>Packaging</p>
          </motion.div>

          <motion.div
            animate={{ y: [0, -8, 0] }}
            transition={{ repeat: Infinity, duration: 5.8 }}
            className='absolute right-12 top-44 bg-white/90 backdrop-blur shadow-lg rounded-xl px-4 py-3 border border-black/10 flex items-center gap-2'
          >
            <Truck size={18} className='text-[#C9A227]' />
            <p className='text-sm font-semibold text-[#1B1B1B]'>Logistics</p>
          </motion.div>

          {/* Center Core */}
          <motion.div
            whileHover={{ scale: 1.06 }}
            className='relative z-10 h-44 w-44 rounded-full bg-gradient-to-r from-[#F47C20] to-[#E83E6F] flex items-center justify-center shadow-2xl'
          >
            <div className='absolute inset-1 rounded-full bg-[#0F1C24]/20 blur-xl' />
            <div className='relative flex flex-col items-center gap-2 text-white'>
              <MapPinned size={34} />
              <p className='text-xs font-semibold tracking-widest uppercase opacity-90'>
                Global Export
              </p>
            </div>
          </motion.div>

          {/* Subtle sparkle */}
          <motion.div
            className='absolute -bottom-6 right-16 text-[#C9A227]'
            animate={{ opacity: [0.3, 1, 0.3], rotate: [0, 12, 0] }}
            transition={{ repeat: Infinity, duration: 4 }}
          >
            <Sparkles size={20} />
          </motion.div>
        </div>
      </div>
    </section>
  )
}
